/**
 * This function generates a random string of the specified length using uppercase letters, lowercase letters, and digits.
 * @param length The length of the random string to generate
 * @returns A random string of the specified length
 * @example
 * randomString(10) // returns a random string like 'aB3dE5fG1h'
 */
export function randomString(length: number): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  let result = ''
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength)
    result += characters[randomIndex]
  }
  return result
}
